import { Correspondence } from './correspondence';

export class GroupedCorrespondence {
  groupId: number;
  correspondenceList: Array<Array<Correspondence>>;

  constructor(groupId: number, correspondenceList: Array<Array<Correspondence>>) {
    this.groupId = groupId;
    this.correspondenceList = correspondenceList;
  }
}
